export enum ButtonText {
  Cancel = 'CANCEL',
  Save = 'SAVE',
  TryAgain = 'TRY AGAIN',
  Confirm = 'CONFIRM',
  Close = 'CLOSE',
}
